import script from "./_about-me.vue?vue&type=script&setup=true&lang=js"
export * from "./_about-me.vue?vue&type=script&setup=true&lang=js"

import "./_about-me.vue?vue&type=style&index=0&id=9cbd5dea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cbd5dea"]])

export default __exports__